export default "__VITE_ASSET__BSGZyaf4__"